import { wrapPageElement as wrap } from './root-wrapper'

export const wrapPageElement = wrap
